/* ---------- in-page anchors ----------
   The header is sticky, so a plain jump-link parks the target underneath it and
   the customer lands on a heading they cannot read. Offset by the real measured
   header height rather than a guessed number, and respect the reduced-motion
   setting instead of forcing a smooth scroll on everyone. */
(function(){
  function headerH(){
    var h = document.getElementById('siteHeader') || document.querySelector('header');
    return h ? h.getBoundingClientRect().height + 14 : 90;
  }
  function reduced(){
    try { return window.matchMedia('(prefers-reduced-motion: reduce)').matches; }
    catch(e){ return false; }
  }
  function jump(el){
    var y = el.getBoundingClientRect().top + window.scrollY - headerH();
    try { window.scrollTo({top: y, behavior: reduced() ? 'auto' : 'smooth'}); }
    catch(e){ window.scrollTo(0, y); }
  }

  document.addEventListener('click', function(e){
    if(e.defaultPrevented) return;
    var a = e.target && e.target.closest && e.target.closest('a[href*="#"]');
    if(!a) return;
    var href = a.getAttribute('href') || '';
    var hash = href.slice(href.indexOf('#') + 1);
    if(!hash) return;
    // Only handle links that stay on this page.
    var path = href.split('#')[0];
    if(path && path !== location.pathname && path !== './') return;
    var el = null;
    try { el = document.getElementById(decodeURIComponent(hash)); } catch(err){ el = null; }
    if(!el) return;                       // a real dead link still behaves like one
    e.preventDefault();
    jump(el);
    try { history.replaceState(null, '', '#' + hash); } catch(err){}
  });

  // Arriving with a hash already in the URL, or from another page.
  if(location.hash.length > 1){
    var el = null;
    try { el = document.getElementById(decodeURIComponent(location.hash.slice(1))); } catch(e){ el = null; }
    if(el) setTimeout(function(){ jump(el); }, 60);
  }
})();

/* ---------- delivery dates (spec section 2.3, delivery-line) ----------
   The delivery line is printed by Liquid with the plain estimate ("Usually
   arrives in about 5 business days."). Only when both business-day figures are
   set in Theme settings is that sentence rewritten to real dates, for example
   "Usually arrives Mon, Oct 5 to Wed, Oct 7."

   The rule:
     - Start from today in America/New_York.
     - After the cut-off hour, on a weekend or on a listed holiday, start from
       the next business day.
     - Count the fastest and slowest figures forward in business days,
       skipping Saturdays, Sundays and the listed holidays.

   Dates are handled as calendar days at noon UTC, so no daylight-saving change
   or time zone offset can move a date by one. */
(function(){
  var TZ = 'America/New_York';

  function nyToday(){
    var out = {};
    try {
      var parts = new Intl.DateTimeFormat('en-US', {
        timeZone: TZ, year: 'numeric', month: 'numeric', day: 'numeric',
        hour: 'numeric', hourCycle: 'h23'
      }).formatToParts(new Date());
      parts.forEach(function(p){ out[p.type] = parseInt(p.value, 10); });
    } catch(e){ return null; }
    if(!out.year || !out.month || !out.day) return null;
    if(out.hour === 24) out.hour = 0;
    return out;
  }

  function iso(dt){
    return dt.toISOString().slice(0, 10);
  }
  function isBusiness(dt, holidays){
    var wd = dt.getUTCDay();
    return wd !== 0 && wd !== 6 && !holidays[iso(dt)];
  }
  function nextDay(dt){
    return new Date(dt.getTime() + 864e5);
  }
  function addBusinessDays(dt, n, holidays){
    var cur = dt;
    while(n > 0){
      cur = nextDay(cur);
      if(isBusiness(cur, holidays)) n--;
    }
    return cur;
  }
  function wholeDays(v){
    if(v === null || v === undefined) return null;
    var s = String(v).trim();
    if(!/^\d+(\.0+)?$/.test(s)) return null;
    var n = parseInt(s, 10);
    return (n >= 0 && n <= 60) ? n : null;
  }

  function fmt(){
    try {
      return new Intl.DateTimeFormat('en-US', { weekday: 'short', month: 'short', day: 'numeric', timeZone: TZ });
    } catch(e){ return null; }
  }

  function apply(root){
    var scope = root && root.querySelectorAll ? root : document;
    var lines = scope.querySelectorAll('.bh-delivery[data-bd-min][data-bd-max]');
    if(!lines.length) return;
    var today = nyToday();
    var f = fmt();
    if(!today || !f) return;

    Array.prototype.forEach.call(lines, function(p){
      if(p.getAttribute('data-bh-dated') === '1') return;
      var lo = wholeDays(p.getAttribute('data-bd-min'));
      var hi = wholeDays(p.getAttribute('data-bd-max'));
      if(lo === null || hi === null) return;
      if(hi < lo){ var t = lo; lo = hi; hi = t; }

      var cutoff = parseInt(p.getAttribute('data-cutoff'), 10);
      if(!isFinite(cutoff)) cutoff = 12;

      var holidays = {};
      (p.getAttribute('data-holidays') || '').split(/[\s,;]+/).forEach(function(s){
        if(/^\d{4}-\d{2}-\d{2}$/.test(s)) holidays[s] = 1;
      });

      var start = new Date(Date.UTC(today.year, today.month - 1, today.day, 12));
      if(today.hour >= cutoff || !isBusiness(start, holidays)){
        start = nextDay(start);
        while(!isBusiness(start, holidays)) start = nextDay(start);
      }

      var first = addBusinessDays(start, lo, holidays);
      var last = addBusinessDays(start, hi, holidays);
      var when = lo === hi
        ? 'Usually arrives ' + f.format(first) + '.'
        : 'Usually arrives ' + f.format(first) + ' to ' + f.format(last) + '.';

      var span = p.querySelector('.bh-delivery-t');
      if(!span) return;
      var text = span.textContent || '';
      var at = text.indexOf('Usually arrives');
      span.textContent = (at > -1 ? text.slice(0, at) : (text ? text.replace(/\s*$/, ' ') : '')) + when;
      p.setAttribute('data-bh-dated', '1');
    });
  }

  window.BH = window.BH || {};
  window.BH.deliveryDates = apply;

  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function(){ apply(); });
  else apply();
})();
